module.exports = __webpack_public_path__ + "static/media/trust-wallet.77470bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/trust-wallet.png
// module id = 1876
// module chunks = 146